module.exports = __webpack_public_path__ + "img/neon.3464cfd7.svg";